"use client";

import { useTranslations } from "use-intl";
import { WhatsAppFormatJoinLinks } from "@/components/messaging/WhatsAppFormatJoinLinks";
import { useDistributionAvailability } from "@/hooks/use-distribution-availability";
import { WhatsAppCommunityDemo } from "./-WhatsAppCommunityDemo";
const BENEFITS = ["Discovery", "Formats", "Action"] as const;
function WhatsAppGroupsPage() {
  const t = useTranslations("whatsapp");
  const distributionQuery = useDistributionAvailability();
  const destinationsQuery = {
    data: distributionQuery.data?.whatsapp,
    isLoading: distributionQuery.isLoading
  };
  return <main className="overflow-hidden bg-[#121513] text-[#f7f3ea] selection:bg-[#25D366] selection:text-[#07170d]">
      <section className="relative isolate border-b border-white/10 px-4 py-14 sm:px-8 sm:py-20 lg:px-12 lg:py-24">
        <div className="pointer-events-none absolute inset-0 -z-10 opacity-80" aria-hidden="true" style={{
        background: "radial-gradient(circle at 82% 14%, rgba(37, 211, 102, 0.17), transparent 30%), radial-gradient(circle at 8% 94%, rgba(255, 120, 66, 0.14), transparent 32%)"
      }} />
        <div className="mx-auto grid max-w-6xl items-center gap-14 lg:grid-cols-[minmax(0,1.12fr)_minmax(22rem,.72fr)]">
          <div className="max-w-3xl">
            <h1 className="text-balance text-4xl font-black leading-[1.04] tracking-[-0.04em] sm:text-6xl lg:text-7xl">
              {t("headline")}
            </h1>
            <p className="mt-6 max-w-[68ch] text-pretty text-lg leading-8 text-[#cbc7be] sm:text-xl">
              {t("intro")}
            </p>

            <div className="mt-9">
              <WhatsAppDestinationActions destinations={destinationsQuery.data?.destinations} loading={destinationsQuery.isLoading} />
            </div>
            <p className="mt-5 max-w-xl text-sm leading-6 text-[#999f99]">{t("safetyNote")}</p>
          </div>

          <WhatsAppCommunityDemo />
        </div>
      </section>

      <section className="px-4 py-14 sm:px-8 sm:py-16 lg:px-12 lg:py-20">
        <div className="mx-auto max-w-6xl">
          <h2 className="max-w-2xl text-balance text-3xl font-black tracking-tight sm:text-4xl">
            {t("benefitsTitle")}
          </h2>
          <div className="mt-8 grid border-y border-white/10 md:grid-cols-3 md:divide-x md:divide-white/10">
            {BENEFITS.map(benefit => <article className="py-7 md:px-7 md:first:pl-0 md:last:pr-0" key={benefit}>
                <h3 className="text-xl font-black">{t(`benefit${benefit}Title`)}</h3>
                <p className="mt-3 max-w-[65ch] text-sm leading-6 text-[#aaa79f]">
                  {t(`benefit${benefit}Description`)}
                </p>
              </article>)}
          </div>
        </div>
      </section>
    </main>;
}
function WhatsAppDestinationActions({
  destinations,
  loading
}: {
  destinations?: {
    vinyl: {
      invitationUrl: string;
    } | null;
    cd: {
      invitationUrl: string;
    } | null;
  };
  loading: boolean;
}) {
  const t = useTranslations("whatsapp");
  const hasFormatDestination = Boolean(destinations?.vinyl || destinations?.cd);
  if (loading) {
    return <div className="grid gap-3 sm:grid-cols-2" aria-hidden="true">
        <div className="h-28 animate-pulse rounded-2xl bg-white/8 motion-reduce:animate-none" />
        <div className="h-28 animate-pulse rounded-2xl bg-white/8 motion-reduce:animate-none" />
      </div>;
  }
  return <>
      {hasFormatDestination ? <WhatsAppFormatJoinLinks destinations={destinations} surface="whatsapp_groups_page" /> : <div className="max-w-xl rounded-2xl border border-amber-300/20 bg-amber-200/8 p-5" role="status">
          <p className="font-black text-amber-100">{t("directUnavailableTitle")}</p>
          <p className="mt-1 text-sm leading-6 text-amber-100/70">
            {t("directUnavailableDescription")}
          </p>
        </div>}
    </>;
}
export { WhatsAppGroupsPage as component };